module.exports = __webpack_public_path__ + "img/Cheryl.20afb08a.png";